import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: React.ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [displayChildren, setDisplayChildren] = useState(children);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Na primeira renderização, não fazer animação
    if (isFirstRender.current) {
      isFirstRender.current = false;
      setDisplayChildren(children);
      return undefined;
    }

    // Quando a rota muda, fazer fade out
    setIsVisible(false);

    // Após o fade out, atualizar o conteúdo e fazer fade in
    const timer = setTimeout(() => {
      setDisplayChildren(children);
      setIsVisible(true);
    }, 150);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Atualizar children sem animação se for a mesma rota
  useEffect(() => {
    if (isFirstRender.current) return;
    setDisplayChildren(children);
  }, [children]);

  return (
    <div
      className={`transition-opacity duration-200 ease-in-out ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      {displayChildren}
    </div>
  );
}
